import { render, staticRenderFns } from "./OnboardingPlans.vue?vue&type=template&id=1a28f549&scoped=true"
import script from "./OnboardingPlans.vue?vue&type=script&lang=js"
export * from "./OnboardingPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a28f549",
  null
  
)

export default component.exports